import { useState } from "react";
import { endingAnalysis } from "@/mocks/lustCaution";

export default function Ending() {
  const [open, setOpen] = useState(0);

  return (
    <section id="ending" className="w-full bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-4xl mx-auto">
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-primary-600 font-label text-sm tracking-widest uppercase">Ending</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug">
              结局解析：那个没有答案的转身
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              影片结束得极其克制，把判断留给了观众。下面这几个问题，几乎是每个看完的人都会追问的。
            </p>
          </div>

          <div className="mt-10 space-y-4">
            {endingAnalysis.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}